import { render, staticRenderFns } from "./circleType.vue?vue&type=template&id=1b063e9e&scoped=true&"
import script from "./circleType.vue?vue&type=script&lang=js&"
export * from "./circleType.vue?vue&type=script&lang=js&"
import style0 from "./circleType.vue?vue&type=style&index=0&id=1b063e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b063e9e",
  null
  
)

export default component.exports